import React, { useState, useEffect } from 'react';
import SliderItem from './SliderItem';


export default function SliderList( {array} ) {
const [open, setOpen] = useState(0)

const select = (e) => {
    setOpen(e)
}
  return (
    <div className='slider-list'>
        {array.map((e, index) => 

            <SliderItem key={index} {...e} open={open} select={select} index={index} />
        )}
    </div>
  )
}
